import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'saleTotal',pure:false })
export class SaleTotalPipe implements PipeTransform {
  
  constructor(private translateService:TranslateService, private currencyPipe:CurrencyPipe){
  }
  transform(sale, type?, displayMode?) {
    let display:string = ""; 
    const status = sale.finances?.totals?.amountStatus;
    const currency = sale?.details?.currency.toUpperCase();
    const priceMode = sale.details?.priceMode;
    if(!displayMode || displayMode === 'priceOnly'){
      display += status=='estimated'?'±':'';
      let price = priceMode === 'VATExcluded' ?sale?.finances?.VATExcluded?.[type || 'products'] : sale?.finances?.VATIncluded?.[type || 'products'];
      price = price || 0;
      display += this.currencyPipe.transform(price,currency.toUpperCase());
    }
    if(!displayMode || displayMode === 'detailsOnly'){
      display += priceMode === 'VATExcluded' ? this.translateService.instant('tax.VATExcludedShort'): '';
    }
    return display;
  }
}